import { Icon } from '@insio/ui-toolkit';

export interface HelpSectionProps {
  title: string;
  children: React.ReactNode;
  testId?: string;
}

/** A titled list inside a help modal. */
export function HelpSection({ title, children, testId }: HelpSectionProps) {
  return (
    <section className='flex flex-col gap-sm' data-testid={testId}>
      <h3 className='text-sm font-semibold text-foreground-base'>{title}</h3>
      <ul className='flex flex-col gap-xs'>{children}</ul>
    </section>
  );
}

export interface HelpItemProps {
  icon: 'check' | 'circle-info';
  text: string;
}

/** One line of a help section with a leading icon. */
export function HelpItem({ icon, text }: HelpItemProps) {
  return (
    <li className='flex items-start gap-sm text-sm text-foreground-muted'>
      <Icon name={icon} className='mt-2xs h-3.5 w-3.5 shrink-0 text-primary-base' />
      <span className='min-w-0'>{text}</span>
    </li>
  );
}
